import { UserTypeEnum } from 'enums';
import { useAuthUser } from 'features/auth/AuthUserContext';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

/**
 * High Order Component to redirect journal users to my-account/overview
 * @param {React.Component} Component
 * @returns {React.Component} WrappedComponent
 */
export function withJournalRedirect(Component) {
  return function WrappedComponent(props) {
    const { user } = useAuthUser();
    const router = useRouter();

    useEffect(() => {
      if (user?.tp_user === UserTypeEnum.JOURNAL) {
        router.push('/my-account/overview/');
      }
    }, [user]);

    return user?.tp_user !== UserTypeEnum.JOURNAL ? <Component {...props} /> : null;
  };
}
